import { Pipe, PipeTransform } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  selectEntitiesById,
  selectEntitiesByType,
  selectEntityById,
  selectRequestById,
} from './drupal-data.selectors';
import { JsonApiQuery } from '../json-api.query';

export function getEntityById<T>(store: Store<any>, id: string | undefined) {
  if (id) {
    return store.pipe(select(selectEntityById(id))) as unknown as T;
  }
  return EMPTY;
}

export function getEntitiesById<T>(
  store: Store<any>,
  ids: string[] | undefined
) {
  if (ids) {
    return store.pipe(select(selectEntitiesById(ids))) as unknown as T;
  }
  return EMPTY;
}

@Pipe({
  name: 'getEntity',
  standalone: true,
})
export class GetEntityPipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform<T>(id: string | undefined): Observable<T | undefined> {
    return getEntityById<Observable<T | undefined>>(this.store, id);
  }
}

@Pipe({
  name: 'getEntities',
  standalone: true,
})
export class GetEntitiesPipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform<T>(ids: string[] | undefined): Observable<T | undefined> {
    return getEntitiesById<Observable<T | undefined>>(this.store, ids);
  }
}

@Pipe({
  name: 'getEntitiesByType',
  standalone: true,
})
export class GetEntitiesByTypePipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform<T>(type: string): Observable<T[]> {
    return this.store.pipe(select(selectEntitiesByType<any>(type)));
  }
}

@Pipe({
  name: 'getRequest',
  standalone: true,
})
export class GetRequestPipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform(id: string | undefined): Observable<JsonApiQuery | undefined> {
    return this.store.pipe(select(selectRequestById(id)));
  }
}

/*
@Pipe({
  name: 'getSeoData',
  standalone: true,
})
export class GetSeoDataPipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform(id: string | undefined): Observable<SeoSocialShareData | undefined> {
    return getEntityById<Observable<DrupalEntity | undefined>>(this.store, id).pipe(
      switchMap(entity => {
        if(entity){
          if(entity.title){

          }
          const seo: SeoSocialShareData = {

          }
          return seo;
        }
        return of(undefined);
      })
    );
  }
}
*/
